declare const RUNNING_ENV: "local" | "preview" | "development" | "staging" | "production" | "test";

export const getBaseURL = (): string => {
  if (RUNNING_ENV === "local") {
    return "http://localhost:3443";
  }
  if (RUNNING_ENV === "development") {
    return "https://api.storytell-development.ai";
  }
  // if (RUNNING_ENV === "preview") {
  //   return err(new Error("Preview environments are not yet implemented"));
  // }
  if (RUNNING_ENV === "staging") {
    return "https://api.storytell-staging.ai";
  }
  return "https://api.storytell.ai";
};
